var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"variant":_vm.statusClass,"title":_vm.statusText},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }